import { connect } from "react-redux";

import Boosts from "apps/boosts/components/Desktop";

import {
	close,
	fetchProductPackages,
} from "ducks/boosts";

function mapStateToProps(state) {
	return state.boosts;
}

const mapDispatchToProps = {
	fetchProductPackages,
	close,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(Boosts);



// WEBPACK FOOTER //
// ./src/apps/boosts/containers/Desktop/index.jsx